import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { collection, getDocs, query, where, orderBy, Timestamp } from "firebase/firestore";
import { db } from "../firebase.js";
 
import { Helmet } from "react-helmet"; 
import Header from "../body_root/header";
import Footers from "../body_root/footer";
import Navbar from "../body_root/Navbar";
import { Toast } from "../components_root/ToastContext";
import Statusbar from '../body_root/statusbar.jsx';

export default function Install_app() {
  const navigate = useNavigate();
  const [islogin, setIslogin] = useState(false);
  const { Toastshow } = Toast();
  const [isLoading, setIsLoading] = useState(true);
  const [profiledata, setProfiledata] = useState([]);
  const [price, setPrice] = useState('0000000');
  const [guid, setguid] = useState('');
  const [error, setError] = useState(null); 

  const deferredPrompt = useRef(null);
  const [showInstallBanner, setShowInstallBanner] = useState(false);

  // Check if app is already installed
  useEffect(() => {
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setShowInstallBanner(false);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      deferredPrompt.current = e;
      setShowInstallBanner(true);
      // Persist banner so it survives reload unless install prompt dismissed/accepted
      localStorage.setItem('showInstallBanner', 'true');
    };

    window.addEventListener('beforeinstallprompt', handler);

    // Restore banner after reload if needed
    if (localStorage.getItem('showInstallBanner') === 'true') {
      setShowInstallBanner(true);
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt.current) return;

    deferredPrompt.current.prompt();

    const choiceResult = await deferredPrompt.current.userChoice;
    if (choiceResult.outcome === 'accepted') {
      console.log('User accepted the install prompt');
    } else {
      console.log('User dismissed the install prompt');
    }
    deferredPrompt.current = null;
    setShowInstallBanner(false);
    localStorage.removeItem('showInstallBanner');
  };

  return (
    <div>
      <Statusbar data={"Install app"} />
     <Helmet>
  <title>Aooz App | Install and Explore Digital Solutions</title>
  <meta
    name="description"
    content="Install the Aooz app to access powerful tools for website development, app creation, digital marketing, and social media management—all in one platform."
  />
  <meta
    name="keywords"
    content="Aooz app, install Aooz, digital solutions, website development, app development, software services, digital marketing, social media management"
  />
  <meta name="author" content="aooz.in" />
  <meta name="robots" content="index, follow" />

  <meta property="og:title" content="Install Aooz App | Digital Solutions for Your Business" />
  <meta
    property="og:description"
    content="Get the Aooz app today and unlock smart solutions for websites, apps, marketing, and more. Designed to grow your business digitally."
  />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://www.aooz.in/install-app" />
  <meta property="og:image" content="https://www.aooz.in/assets/Aooz-app.png" />
</Helmet>
      <div className="container_roots">
        <div className="container_size">
          <div className='post-container'>
            <div className='post_div'>
              <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: 800, margin: 'auto', padding: 20 }}>
                <div>
                  <div className='contact-title bold'>How to InstallAooz App</div>
                </div> 
                <br />
                <div>
                  {showInstallBanner && (
                    <div className='contact-title items-back' style={{padding:'5px 10px'}}>
                      <a>Install the Aooz app for faster access!</a>
                      <br/><br/>
                      <div className='button-ui fill blue-back bold' onClick={handleInstallClick}>
                        Install App
                      </div>
                    </div>
                  )}
                </div>
                <h3>On Android (Chrome, Brave, Edge):</h3>
                <ol className='contact-header'>
                  <li>Open <a href="https://aooz.in" target="_blank" rel="noreferrer">aooz.in</a> in your browser.</li>
                  <li>Wait for the page to fully load.</li>
                  <li>Look for the “Install App” prompt or banner and tap “Install”.</li>
                  <li>The app will be added to your home screen.</li>
                </ol>
                <h3>On iPhone (Safari):</h3>
                <ol className='contact-header'>
                  <li>Open Safari and navigate to <a href="https://aooz.in" target="_blank" rel="noreferrer">aooz.in</a>.</li>
                  <li>Tap the Share button (square with arrow up).</li>
                  <li>Scroll down and tap “Add to Home Screen”.</li>
                  <li>Tap “Add” to confirm.</li>
                </ol>
                <h3>On Desktop (Chrome, Edge):</h3>
                <ol className='contact-header'>
                  <li>Open <a href="https://aooz.in" target="_blank" rel="noreferrer">aooz.in</a> in Chrome or Edge.</li>
                  <li>Click the install icon in the address bar (computer with down arrow).</li>
                  <li>Click “Install”.</li>
                  <li>The app will open in its own window.</li>
                </ol>
                <h3>Tips</h3>
                <ul>
                  <li>Use an updated browser for best experience.</li>
                  <li>If no install prompt appears, try clearing cache and reloading.</li>
                  <li>Enable notifications and allow app permissions for full features.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
     
      
    </div>
  );
}